import { useState } from "react"

/**
 * Like useState but keeps value persistent between refreshes using localStorage.
 *
 * @param {string} keyName - Must be unique for the whole app.
 * @param {any} defaultValue - Default value if nothing is in localStorage.
 * @param {boolean} skipLocalStorage - If true, skip using localStorage and use default value only.
 */
export function useLocalStorage(keyName, defaultValue = undefined, skipLocalStorage = false) {
  function getDefaultValue() {
    if (
      !skipLocalStorage &&
      typeof window !== "undefined" &&
      window.localStorage &&
      window.localStorage.getItem(keyName) !== null &&
      window.localStorage.getItem(keyName) !== "undefined"
    ) {
      try {
        return JSON.parse(window.localStorage.getItem(keyName))
      } catch {
        return defaultValue
      }
    }
    return defaultValue
  }

  const [value, setValue] = useState(getDefaultValue)

  const setStoredValue = (newValue) => {
    setValue(newValue)
    if (!skipLocalStorage && typeof window !== "undefined" && window.localStorage) {
      window.localStorage.setItem(keyName, JSON.stringify(newValue))
    }
  }

  return [value, setStoredValue]
}